// ⚠️ PR #74 - xime: Este archivo fue restaurado al estado pre-pull (commit 4999deb).
// Cambios que hizo el PR (pendientes de revisar/integrar cuando se necesite):
// - taskruleweights → task_rule_weight, taskrulelabel → task_rule_labels, taskruleparameters → task_rule_parameters
// - getTaskById() → getTaskByIdRecursive() en LoadTaskDetail()
// - task_rule_parameters_data: accede a task_rule_parameters con rule_parameter.key en vez de ruleparameter.key
// - Nuevos métodos: buildTaskRuleLabelsPayload(), buildTaskRuleWeightsPayload()
// - setParameterTemplate(): rellena peso/label automáticamente al seleccionar regla
// - Estructura del payload en data_for_save y transformDataForUpdate() cambió completamente
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SearchAutocompleteComponent } from '../search-autocomplete/search-autocomplete.component';
import { map, Observable } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RulesService } from '../../rules/rules.service';
import { MissionsService } from '../../../services/missions.service';
import { MatIconModule } from '@angular/material/icon';
import { DynamicFormsComponent } from '../dynamic-forms/dynamic-forms.component';
import { DynamicFormField, FieldType } from '../dynamic-forms/model';
import { Rule, RuleParameter } from '../../../models/rules';
import { TaskRuleParameter } from '../../../models/task_rule';
import { MatExpansionModule } from '@angular/material/expansion';
import { TaskModel } from '../../../models/task_model';

function typeConvertion(type: string) {
  let t: FieldType
  switch (type) {
    case 'str':
    case 'list':
    case 'string':
      t = 'string'
      break;
    case 'json':
      t = 'textarea'
      break;
    case 'bool':
    case 'boolean':
      t = 'boolean'
      break;

    default:
      t = 'string'
      break;
  }
  return t
}

@Component({
  selector: 'app-dialog-task-rule-params',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatDialogTitle, MatDialogContent, FormsModule, ReactiveFormsModule, AutoCompleteModule, SearchAutocompleteComponent, MatButtonModule, MatFormFieldModule, MatInputModule, MatIconModule, MatExpansionModule,
    DynamicFormsComponent
  ],
  templateUrl: './dialog-task-rule-params.component.html',
  styleUrl: './dialog-task-rule-params.component.scss'
})
export class DialogTaskRuleParamsComponent {


  $FORM_CONFIG!: Observable<DynamicFormField[]>
  rules$: Observable<Rule[]>
  state: string = 'creando';
  disableInput: boolean = true;
  task_rule_parameters_data!: any
  task_rule_parameters!: any
  isRuleAssigned: string[] = [];
  taskRuleForm: FormGroup;
  isEditing = false;

  rule_id!: number
  task_id!: number
  task_rule_id!: number
  rule_parameters: any = {}
  data_for_save = {}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private rulesService: RulesService,
    private missionsService: MissionsService,
    private dialogRef: MatDialogRef<DialogTaskRuleParamsComponent>
  ) {
    this.taskRuleForm = this.fb.group({
      taskruleweights: [this.data.data !== 'nuevo' ? this.data.data.taskruleweights?.weight || 0.5 : 0.5],
      taskrulelabel: [this.data.data !== 'nuevo' ? this.data.data.taskrulelabel?.value || 'Ingresa un nuevo nombre' : 'Ingresa un nuevo nombre'],
    });

    this.task_id = this.data.task_id;
    this.rule_id = this.data.data.rule_id;
    this.task_rule_id = this.data.data.task_rule_id;
    this.rules$ = this.rulesService.getRules();

    if (this.rule_id) this.setParameterTemplate();

    if (this.data.data != 'nuevo') {
      this.state = 'exist'
      this.task_rule_parameters_data = this.data.data.taskruleparameters.reduce((acc: any, item: TaskRuleParameter) => {
        acc[item.ruleparameter.key] = this.parseValue(item.value ? item.value : '')
        return acc;
      }, {})
    } else {
      this.disableInput = false;
    }
  }

  setParameterTemplate() {
    const taskmodels = this.data.taskmodels ?? []
    this.$FORM_CONFIG = this.rulesService.getRuleById(this.rule_id).pipe(
      map((rule: RuleParameter) => {
        const models_options = taskmodels.map((task_model: TaskModel) => {
          return {
            label: task_model.model.name,
            value: task_model.model.model_key
          }
        })

        const update_recursive_models = (value: DynamicFormField, key: FieldType) => {
          if (value.fields) {
            value.fields?.forEach(element => {
              if (element.fields) {
                update_recursive_models(element, key)
              } else if (element.type === key && element.name === 'model_key') {
                element.options = models_options
              }
            });
          } else if (value.type === key && value.name === 'model_key') {
            value.options = models_options
          }
          return value
        }

        const template: DynamicFormField[] = (rule.rulesparameters ?? []).map((r) => {
          this.rule_parameters[r.key] = r.rule_parameter_id
          const parsed_template = this.parseInputValidator(r.input_validator)

          if (parsed_template) {
            return update_recursive_models(parsed_template, 'model')
          }

          return {
            type: r.format ? typeConvertion(r.format) : typeConvertion('string'),
            name: r.key ? r.key : 'Sin definir',
            label: r.input_validator?.trim() || r.key || 'Sin definir'
          }
        })

        console.log('template', template)
        return template
      })
    )
  }

  stringifyValues(value: any) {
    switch (typeof value) {
      case 'string':
      case 'boolean':
      case 'number':
        return `${value}`
      case 'object':
        return JSON.stringify(value)
      case undefined:
        return ''
      default:
        return `${value}`
    }

  }

  parseValue(value: any) {
    const str = value.trim();

    if (str === 'true') return true;
    if (str === 'false') return false;

    if (!isNaN(str)) return Number(str);

    try {
      return JSON.parse(str.replace(/'/g, '"'))
    } catch (e) {
      return value;
    }
  }

  private parseInputValidator(raw: string | null | undefined): DynamicFormField | null {
    if (!raw) return null;

    const value = raw.trim();
    if (!value) return null;

    // Si es texto plano, no intentamos tratarlo como JSON.
    if (!value.startsWith('{') && !value.startsWith('[')) {
      return null;
    }

    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' ? parsed as DynamicFormField : null;
    } catch (error) {
      console.warn('input_validator no es JSON válido, se usará fallback simple:', raw, error);
      return null;
    }
  }




  form1!: FormGroup;

  // Example config
  config = {
    type: 'matrix',
    name: 'matriz_uno',
    default: [
      [[0]]
    ] as number[][][]
  };

  ngOnInit(): void {
    
    this.form1 = this.fb.group({
      [this.config.name]: this.fb.array([])
    });
    this.loadDefaultMatrix();

    this.LoadTaskDetail()
    this.taskRuleForm.valueChanges.subscribe(v => {
      this.data_for_save = {
        rule_id: this.rule_id,
        task_id: this.task_id,
        taskruleweights: { weight: this.taskRuleForm.value.taskruleweights },
        taskrulelabel: {
          value: this.taskRuleForm.value.taskrulelabel
        },
        taskruleparameters: this.task_rule_parameters
      };
      console.log('data_for_save', this.data_for_save)
    })
  }

  private loadDefaultMatrix() {
    const matricesFA = this.matricesFA;
    this.config.default.forEach(matrixData => {
      const rowsFA = this.fb.array<FormGroup<{ cells: FormArray<FormControl<number | null>> }>>([]);
      matrixData.forEach(cellArray => { 
        const cellFA = this.fb.array(
          cellArray.map(n => this.fb.control<number | null>(n))
        );
        // *** FIX: Wrap the cell FormArray in a FormGroup ***
        rowsFA.push(this.fb.group({ cells: cellFA }));
      });

      // Push the FormGroup representing the matrix (which contains the rowsFA)
      matricesFA.push(this.fb.group({ rows: rowsFA }));
    });
  }

  // Getter for the top-level FormArray of matrices
  get matricesFA(): FormArray {
    return this.form1.get(this.config.name) as FormArray;
  }

  // Used by *ngFor="let rowGroup of getRowsControls(mi); let ri = index"
  getRowsControls(matrixIndex: number): AbstractControl[] { // Returns FormGroup[] effectively
    const matrixGroup = this.matricesFA.at(matrixIndex) as FormGroup;
    const rowsArray = matrixGroup.get('rows') as FormArray;
    return rowsArray.controls;
  }

  // Used by *ngFor="let cell of getCellsControls(mi, ri); let ci = index"
  getCellsControls(matrixIndex: number, rowIndex: number): FormControl[] {
    const matrixGroup = this.matricesFA.at(matrixIndex) as FormGroup;
    const rowsFA = matrixGroup.get('rows') as FormArray;
    const rowGroup = rowsFA.at(rowIndex) as FormGroup;
    const cellsFA = rowGroup.get('cells') as FormArray;
    return cellsFA.controls as FormControl[];
  }
  addMatrix() {
    const rowsFA = this.fb.array<FormGroup<{ cells: FormArray<FormControl<number | null>> }>>([]);
    const defaultCellsFA = this.fb.array([this.fb.control<number | null>(0)]);
    const defaultRowGroup = this.fb.group({ cells: defaultCellsFA });
    rowsFA.push(defaultRowGroup);
    this.matricesFA.push(this.fb.group({ rows: rowsFA }));
  }

  removeMatrix(mi: number) {
    this.matricesFA.removeAt(mi);
  }

  addRow(mi: number) {
    const matrixGroup = this.matricesFA.at(mi) as FormGroup;
    const rowsFA = matrixGroup.get('rows') as FormArray;
    const newCellFA = this.fb.array([
      this.fb.control(0),
      this.fb.control(0),
      this.fb.control(0)
    ]);
    rowsFA.push(this.fb.group({ cells: newCellFA }));
  }

  removeRow(mi: number, ri: number) {
    const matrixGroup = this.matricesFA.at(mi) as FormGroup;
    const rowsFA = matrixGroup.get('rows') as FormArray;
    rowsFA.removeAt(ri);
  }

  addCell(mi: number, ri: number) {
    const matrixGroup = this.matricesFA.at(mi) as FormGroup;
    const rowsFA = matrixGroup.get('rows') as FormArray;
    const rowGroup = rowsFA.at(ri) as FormGroup;
    const cellsFA = rowGroup.get('cells') as FormArray;
    cellsFA.push(this.fb.control<number | null>(0));
  }


  removeCell(mi: number, ri: number, ci: number) {
    const matrixGroup = this.matricesFA.at(mi) as FormGroup;
    const rowsFA = matrixGroup.get('rows') as FormArray;
    const rowGroup = rowsFA.at(ri) as FormGroup;
    const cellsFA = rowGroup.get('cells') as FormArray;
    cellsFA.removeAt(ci);
  }


  getResult(): number[][][] {
    return this.matricesFA.value.map((matrixGroup: { rows: { cells: number[] }[] }) => {
      return matrixGroup.rows.map((rowGroup: { cells: number[] }) => rowGroup.cells);
    });
  }

  LoadTaskDetail() {
    this.missionsService.getTaskById(this.task_id).subscribe((task) => {
      if (Array.isArray(task.tasksrules)) {
        this.isRuleAssigned = task.tasksrules.map((rule: any) => rule.rule_id);
      } else {
        console.error('taskRule no contiene datos válidos.');
      }
    });
  }

  onValueChange(event: any) {
    this.data_for_save = this.transformDataForUpdate(event)
  }

  saveRuleTaskParms() {
    if (!Object.keys(this.data_for_save).length) {
      alert('El formulario no es valido.')
      throw new Error("not_data");
    }

    let resultType;
    if (this.state === 'creando') {
      resultType = 'nuevo';
    } else {
      resultType = 'existente';
    }
    this.dialogRef.close({ data: { ...this.data_for_save }, type: resultType });
  }


  isRulesAssigned(ruleId: string): boolean {
    return this.isRuleAssigned.includes(ruleId)
  }

  transformDataForUpdate(inputData: any) {
    this.task_rule_parameters = Object.keys(inputData).map(key => {
      const current = this.data?.data?.taskruleparameters?.find((trp: TaskRuleParameter) => trp.ruleparameter.key === key)
      const rule_parameter_id = this.rule_parameters[key]
      if (current) {
        return {
          task_rule_parameter_id: current.task_rule_parameter_id,
          task_rule_id: current.task_rule_id,
          rule_parameter_id: current.rule_parameter_id,
          value: this.stringifyValues(inputData[key]),
        }
      } else {
        return {
          rule_parameter_id: rule_parameter_id,
          value: this.stringifyValues(inputData[key]),
        }
      }
    })


    const task_rule = {
      rule_id: this.rule_id,
      task_id: this.task_id,
      taskruleweights: { weight: this.taskRuleForm.value.taskruleweights },
      taskrulelabel: {
        value: this.taskRuleForm.value.taskrulelabel
      },
      taskruleparameters: this.task_rule_parameters
    };
    return task_rule;
  }


  onItemSelected(item: any): void {
    this.rule_id = item.rule_id
    this.setParameterTemplate()
  }

}
